// extracted by mini-css-extract-plugin
export default {"container":"container__sKPXi","icon":"icon__I_Hc2","success-icon":"success-icon__vo5E9"};